import { render } from "./BaseCloseButton.vue?vue&type=template&id=fe3b217e&scoped=true"
const script = {}

import "./BaseCloseButton.vue?vue&type=style&index=0&id=fe3b217e&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3b217e"]])

export default __exports__